import { createFileRoute } from '@tanstack/react-router'
import { GroupsPage } from '~/features/organizer-groups/ui/groups-page'

export const Route = createFileRoute('/dashboard/groups')({
  component: GroupsPage,
})
